<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>적하보험 회원가입</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>적하보험 회원가입</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<h3  v-if="state.sType == '1'" class="conTit">사업자</h3>
					<h3  v-if="state.sType == '2'" class="conTit">개인담당자</h3>
					<div class="tabStyle1">
						<table>
							<caption>회원가입</caption>
							<colgroup>
								<col width="200">
								<col width="400">
								<col width="200">
								<col width="400">
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">
										<label for="ID">ID</label>
									</th>
									<td colspan="3">
										<div class="typeSplit5">
											<div class="inpTxt typeReq">
												<input type="text" maxlength="9"  v-model="state.userInfo.login_id" placeholder="영문, 숫자, 영문+숫자 6~9자리 이내" id="ID" title="ID">
											</div>
											<a @click="idChk()" class="btnType sizeS colorB"><span>중복확인</span></a>
										</div>
										<p class="inpInfo fcRed">입력전 ID 중복 확인을 먼저 해주시기 바랍니다.</p>
									</td>
								</tr>
								<tr>
									<th scope="row"><label for="pwd">비밀번호</label></th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input maxlength="20" @blur="checkPsw()" v-model="state.userInfo.pwd" type="password" placeholder="비밀번호는 20자리까지 가능" id="pwd" title="비밀번호">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="pwdChk">비밀번호 확인</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input maxlength="20" @blur="checkPsw()" type="password"  v-model="state.userInfo.rePwd" id="pwdChk" title="비밀번호 확인">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobKo">직장한글명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input maxlength="19" v-model="state.userInfo.n_ctorkr" type="text" id="jobKo" title="직장한글명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobEn">직장영문명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input maxlength="50" @blur="checkEng()" v-model="state.userInfo.n_ctoren" type="text" placeholder="대문자로기입" id="jobEn" title="직장영문명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										사업자구분
									</th>
									<td colspan="3">
										<div class="inpSlt typeReq">
											<button type="button" class="sltBtn" title="사업자구분"><span>법인사업자</span></button>
											<ul>
												<li><button type="button" class="sltOpt"><span>법인사업자</span></button></li><!-- 체크되어있는 버튼에 title="선택" 추가 -->
												<li><button type="button" class="sltOpt"><span>개인사업자</span></button></li>
												<li><button type="button" class="sltOpt" title="선택"><span>서베이</span></button></li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bizNum">사업자번호</label>
									</th>
									<td colspan="3">
										<div class="typeSplit5">
											<div class="inpTxt typeReq">
												<input type="text" readonly maxlength="10" v-model="state.userInfo.biz_no" placeholder="-없이 입력해 주세요" id="bizNum" title="사업자번호">
											</div>
											<a v-if="state.sType != '2'" @click="checkUser()" class="btnType sizeS colorR"><span>사업자공인인증</span></a>
										</div>
									</td>
								</tr>
								<tr v-if="state.sType != '1'">
									<th scope="row">
										<label for="bizNum">업무담당자 주민번호</label>
									</th>
									<td colspan="3">
										<form name="form1" method="post" ref="form1">
											<div class="typeSplit5">
												<div class="inpTxt typeReq">
													<input type="text" v-model="state.userInfo.txtJumin_bf"  maxlength="6" id="txtJumin_bf" title="업무담당자 주민번호">
												</div>
												<span style="margin: 13px 0px 0px 10px">-</span>
												<div class="inpTxt typeReq">
													<input type="password" v-model="state.userInfo.txtJumin_af" maxlength="7" name="txtJumin_af" id="txtJumin_af" npkencrypt="on" title="업무담당자 주민번호">
												</div>
												<a @click="checkUser()" class="btnType sizeS colorR"><span>사업자공인인증</span></a>
											</div>
										</form>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bizNum2">사업자별 식별번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" v-numeric-only maxlength="20" v-model="state.userInfo.biz_idf_no" id="bizNum2" title="사업자별 식별번호">
										</div>
									</td>
								</tr>
								<tr v-if="state.sType != '1'">
									<th scope="row">
										<label for="phone">휴대폰번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no1" maxlength="4"  id="phone1" title="휴대폰번호">-
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no2" maxlength="4"  id="phone2" title="휴대폰번호">-
											<input type="text" style="width:32%" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.celfon_no3" maxlength="4"  id="phone3" title="휴대폰번호">
										</div>
									</td>
								</tr>
								<tr v-if="state.sType != '2'">
									<th scope="row">
										<label for="phone">직장전화</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no1" maxlength="4"  id="phone1" title="직장전화">-
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no2" maxlength="4"  id="phone2" title="직장전화">-
											<input type="text" style="width:32%" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no3" maxlength="4"  id="phone3" title="직장전화">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="fax">FAX</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"   v-model="state.userInfo.fax_no1"  id="fax1" title="FAX">-
											<input type="text" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"  v-model="state.userInfo.fax_no2"  id="fax2" title="FAX">-
											<input type="text" style="width:32%" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"   v-model="state.userInfo.fax_no3"  id="fax3" title="FAX">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bir">생년월일</label>
									</th>
									<td colspan="3">
										<div class="form_input_area type_calendar inpTxt typeReq" style="width:32%">
											<datepicker
												v-model="state.userInfo.birth_ymd"
												:locale="ko"
												class="form_input"
												inputFormat="yyyy-MM-dd"
												readonly
											/>
											<button type="button" class="btn_calendar">
												<span>날짜선택</span>
											</button>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="division">부서</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="10" v-model="state.userInfo.dept_nm" type="text" id="division" title="부서">
										</div>
									</td>
									<th scope="row">
										<label for="name">담당자명</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input v-model="state.userInfo.charg_nm" type="text" id="name" title="담당자명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="code">담당자코드</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input maxlength="9" type="text" @blur="checkNum()" v-model="state.userInfo.gita" placeholder="현재 거래하고 있는 메리츠화재 영업직원(대리점포함)의 사원번호를 입력하여 주십시오." id="code" title="담당자코드">
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<p class="inpInfo fcRed">청약입력을 위해서는 반드시 '공인인증'을 거쳐 사업자용ID 생성 후, 업무당사자용ID 생성하셔야 합니다.</p>

					<div class="btnWrap">
						<a @click="memberRegi()" class="btnType sizeS colorB"><span>확인</span></a>
					</div>
				</div>
			</div>
		</div>

</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate, nextTick  } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import util from '@/common/util';
import { sessionUserInfo, load } from '@/common/sessionFactory';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import { globalState } from "@/common/globalState";
import { ko } from 'date-fns/locale';
import Datepicker from 'vue3-datepicker';

const store = useStore();
const swalAlert = inject("swalAlert");
const axios = inject('axios');
const router = useRouter()

const state = reactive({
	logid : '',
	bizNo : '',
	biz_Idf_No : '',
	txtN_Ctorkr : '',
	txtN_Ctoren : '',
	txtTel_No : '',
	txtFax_No : '',
	dept_nm : '',
	charg_nm : '',
	sType : '',//1
	txtGita: '',
	userInfo : {},
	regiIdChk : false,
	currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),

	athdc_mbdy_enc : '', //공인인증 유효키
	athdc_efct_dt :'', //공인인증 만료일자

});

const idChk = () => {

	if(_.isEmpty(state.userInfo.login_id)){
		return swalAlert("ID를 입력하세요.");
	}
	if(!(state.userInfo.login_id.length > 5 && state.userInfo.login_id.length < 10)){
		return swalAlert('LOGIN ID는 반드시 6자리 이상 9자리 이하로 합니다.');
	}
	const koRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
	if(koRegex.test(state.userInfo.login_id)){
		state.userInfo.login_id = '';
		return swalAlert('한글은 입력 불가능합니다.');
	}

	let param = {};
	param.loginSbcTypCd = state.sType;
	param.logId = state.userInfo.login_id;
	axios.json('/checkId.do', param).then(function(result){
        if(result.data.state == 'Y'){
			state.regiIdChk = true;
        }else{
			state.regiIdChk = false;
        }
		return swalAlert(result.data.msg).then((result) => {
			if(!state.regiIdChk){
				state.userInfo.login_id = "";
			}
         });    
	})

}
onMounted(async () => {	
	
	await npPfsStartup(document.form2, true, true, false, false,"npkencrypt", "on");

	state.userInfo.biz_no = store.state.common.corpNo;
	console.log("state.userInfo.biz_no",state.userInfo.biz_no);
	state.sType = store.state.common.sType
	
	if(state.sType == 2){
		state.userInfo.n_ctorkr = store.state.common.n_ctorkr;
		state.userInfo.n_ctoren = store.state.common.n_ctoren;
		state.userInfo.gita = store.state.common.gita;
	}else{
		state.userInfo.n_ctorkr = '';
		state.userInfo.n_ctoren = '';
		state.userInfo.gita = '';
	}
	state.userInfo.birth_ymd = new Date(state.currDateFormat);
	
	setTimeout(()=>{
		$('.nppfs-elements').hide();
	},'1000')

})



const checkUser = () =>{
	axios.json('/genKsbizNonce.do', {}).then(function(result){
					
		if(result.errorCode != "undefined"){
			KeySharpBiz.sign("ksbizNonce="+result.data.KSBIZ_NONCE, complete_sign, {addNonce:false})	
		}else{
			console.log(result.errorCode);
		}
	})
}

const complete_sign = (result) => {
	const param = {};
	param.ksbizSig = result.data;
	param.idn = state.sType == '1'? state.userInfo.biz_no : state.userInfo.txtJumin_bf;
	param.ksbizVidRandom = result.vidRandom;
	param.sType = state.sType //사업자, 담당자 구분 

	param.e2eRes = $('[name=__E2E_RESULT__]').val();
	param.e2eUni = $('[name=__E2E_UNIQUE__]').val();
	param.e2e = $('[name=txtJumin_af__E2E__]').val();
	param.e2epln = $('[name=txtJumin_af]').val();


	axios.json('/ofapvAthdcElcSgnVrfReg.do', param).then(function(result){
		console.log(result)
		if(result.data.state == 'Y'){
			swalAlert(result.data.msg);
			state.athdc_mbdy_enc = result.data.subjectDN //공인인증 유효키
			state.athdc_efct_dt = result.data.dateafter; //공인인증 만료일자
			
		}else if(result.data.state == 'N'){
			return swalAlert(result.data.msg);
		}
	})
	console.log("Call BACK")
}

const memberRegi = () => {
	if(!state.regiIdChk){
		return swalAlert("ID 중복확인 해주세요.");
	}
	if(_.isEmpty(state.userInfo.pwd)){
		return swalAlert("비밀번호를 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.rePwd)){
		return swalAlert("비밀번호 확인 입력해주세요.");
	}else if(state.userInfo.rePwd != state.userInfo.pwd){
		return swalAlert("비밀번호와 비밀번호 확인이 불일치 합니다.");
	}else if(_.isEmpty(state.userInfo.n_ctorkr)){
		return swalAlert("직장한글명을 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.n_ctoren)){
		return swalAlert("직장영문명을 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.biz_idf_no)){
		return swalAlert("사업자별 식별번호를 입력해주세요.");
	}else if (state.sType != '1'){
		if(_.isEmpty(state.userInfo.celfon_no1) ||_.isEmpty(state.userInfo.celfon_no1) || _.isEmpty(state.userInfo.celfon_no1)){
			return swalAlert("휴대폰번호를 입력해주세요.");
		}
	}else if(state.sType == '1'){
		if(_.isEmpty(state.userInfo.tel_no1) ||_.isEmpty(state.userInfo.tel_no2) || _.isEmpty(state.userInfo.tel_no3)){
			return swalAlert("직장전화번호를 입력해주세요.");
		}
	}else if(_.isEmpty(state.userInfo.fax_no1) || _.isEmpty(state.userInfo.fax_no2) || _.isEmpty(state.userInfo.fax_no3)){
		return swalAlert("FAX를 입력해주세요.");
	}else if(_.isEmpty(util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd'))){
		return swalAlert("생년월일을 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.dept_nm)){
		return swalAlert("부서명을 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.charg_nm)){
		return swalAlert("담당자명을 입력해주세요.");
	}else if(_.isEmpty(state.userInfo.gita)){
		return swalAlert("담당자코드를 입력해주세요.");
	}
	if($(".sltBtn").text() == "서베이"){
		state.userInfo.ind_corp_typ_cd = 'S'
	}else if($(".sltBtn").text() == "개인사업자"){
		state.userInfo.ind_corp_typ_cd = 'P'
	}else{
		state.userInfo.ind_corp_typ_cd = "C"
	}

	let param = {};
	param.loginSbcTypCd = state.sType;
	param.corpNo = state.userInfo.biz_no;
	param.login_id = _.replace(state.userInfo.login_id, /\s+/g, '')
	param.pwd	=	state.userInfo.pwd;
	param.n_ctorkr = state.userInfo.n_ctorkr;
	param.n_ctoren = _.toUpper(state.userInfo.n_ctoren);
	param.biz_no   = state.userInfo.biz_no;
	param.biz_idf_no  = state.userInfo.biz_idf_no;
	param.tel_no1 =	state.userInfo.tel_no1;
	param.tel_no2 =	state.userInfo.tel_no2;
	param.tel_no3 =	state.userInfo.tel_no3;

	param.celfon_no1 =	state.userInfo.celfon_no1;
	param.celfon_no2 =	state.userInfo.celfon_no2;
	param.celfon_no3 =	state.userInfo.celfon_no3;

	param.fax_no1 =	state.userInfo.fax_no1;
	param.fax_no2 =	state.userInfo.fax_no2;
	param.fax_no3 =	state.userInfo.fax_no3;
	param.birth_ymd = util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd');
	param.dept_nm =	state.userInfo.dept_nm;
	param.charg_nm = state.userInfo.charg_nm;
	param.gita = state.userInfo.gita;
	param.ind_corp_typ_cd = state.userInfo.ind_corp_typ_cd;

	param.athdc_mbdy_enc = state.athdc_mbdy_enc;  //공인인증 유효키
	param.athdc_efct_dt = state.athdc_efct_dt;   // 공인인증 만료일자
	param.page = window.location.hash;
	
	if(state.sType == '1'){ //사업자 회원가입
		axios.json('/mbrRegiNew.do', param).then(function(result){
			return swalAlert(result.data.msg).then(async (result1) => {
				router.push({ name: 'main' })
			});
		});
	}else{ //업무담당자 회원가입
		axios.json('/mbrRegi.do', param).then(function(result){
			return swalAlert(result.data.msg).then(async (result1) => {
				router.push({ name: 'main' })
			});
		});
	}
}
//비밀번호 체크
const checkPsw = () => {
	var psw = state.userInfo.pwd;
	var goodFormat =  /^(?=.*\d)(?=.*[a-zA-Z])(?=.*\W).{8,20}$/.test(psw);
	if (!goodFormat) {
		state.userInfo.pwd = "";
		return swalAlert("[비밀번호] 필수: 영문자 + 숫자 + 특수문자  최소 8자 / 최대 20자");
	}			
	var hasDuplicates = /([a-zA-Z0-9])\1{2,}/.test(psw);
	if(hasDuplicates) {
		state.userInfo.pwd = "";
		return swalAlert("[비밀번호] 동일문자 3번이상 사용 금지");
	}
	if(!_.isEmpty(state.userInfo.login_id)){
		var idCheck = new RegExp(state.userInfo.login_id, 'i'); 
		var idDuplicates = idCheck.test(psw);
		if (idDuplicates) {
			form.txtPwd.value = ""; 
			return swalAlert("[비밀번호] 아이디와 동일한 문자 사용 금지");
		}
	}

}
//담당자 코드 체크
const checkNum = () => {
	var Gita = state.userInfo.gita;
	var Gita2 = 0;
	if (Gita == "" || Gita == null){
		Gita2 = 0;
	}else{
		Gita2 = state.userInfo.gita.length;
	}    
	//716020786
	if (Gita2 > 0 ){
		if(Gita2 <= 8){		    	
			state.userInfo.gita ="";
			return swalAlert("담당자코드를 확인하세요.");
		}
		else if(!(Gita.substring(0,1) == "1" || Gita.substring(0,1) == "3" || Gita.substring(0,1) == "5" || Gita.substring(0,1) == "7"))
		{
			state.userInfo.gita="";
			return swalAlert("담당자코드를 확인하세요.");
		}    	
	}	
}

const checkEng = () => {
	const koRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
	if(koRegex.test(state.userInfo.n_ctoren)){
		return swalAlert('한글은 입력 불가능합니다.');
	}
}

function rmSpaceObject(obj){
	return _.mapValues(obj, value => _.isString(value) ? _.trim(value) : value);
}



</script>

<style>

</style>
